import React, { useEffect, useState, useRef } from 'react';
import SubmissionSuccessStyled from './SubmissionSuccessStyled';
import axios from 'axios';
import Card from '../../../../components/card/card';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';

const SubmissionSuccess = () => {
  const [fetchedArticles, setFetchedArticles] = useState();
  const [isLoading, setLoading] = useState(true);
  const headerRef = useRef();

  function fetchArticles() {
    const scrollingModulePosts = `https://fc-api.fastcompany.com/api/v3/scrolling-module-posts/fastcompany?total=20&withBody=true&exclude_from_homepage`;

    axios.get(scrollingModulePosts).then(res => {
      setFetchedArticles(res.data.posts.slice(0, 6));
      setLoading(false);
    });
  }

  useEffect(() => {
    headerRef.current.scrollIntoView({ block: 'center' });
    fetchArticles();
  }, []);

  return (
    <SubmissionSuccessStyled>
      <h2 className="head" ref={headerRef}>
        You’re on the list!
      </h2>
      <p className="subhead">
        Enjoy these trending stories while you wait for your first email to
        arrive:
      </p>
      <div className={`card-wrapper ${isLoading ? '' : 'loaded'}`}>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          fetchedArticles &&
          Array.isArray(fetchedArticles) &&
          fetchedArticles.map(article => (
            <Card
              key={article.id}
              metadata={article}
              config={window.appState.config}
            />
          ))
        )}
      </div>
    </SubmissionSuccessStyled>
  );
};

export default SubmissionSuccess;
